import { map, all, has } from 'ramda'
import { Entity } from 'vms-base'
import { baseLoader } from 'loader'
import { selectors } from '../landscape-state/selectors'

const _poiUpdateQueue = []
let _queueRunning

const scheduleEntityEdits = (venueId, changes, state, updatedPoiCoords, isEntityMigrated) => new Promise((resolve, reject) => {

    const restartQueueAndResolveWithUpdatedEntities = entities => {
        _queueRunning = false
        runQueue()
        resolve(entities)
    }

    _poiUpdateQueue.push(() => {
        _queueRunning = true

        const enrichEntity = updatedEntity => {
            const entity = selectors.findEntity({ id: updatedEntity.entity.id.replace('#', '') })

            if (selectors.isVenueV5(venueId, state)) {
                const featuresForEntity = selectors.featuresForEntity(entity.id)
                const levelId = (updatedPoiCoords ? (selectors.levelAtLatLng(venueId, updatedPoiCoords, state.map.currentOrdinalId, state, false) || selectors.levelIdForEntity(entity)) : selectors.levelIdForEntity(entity))
                updatedEntity           = Entity.enrichUpdateEntity(entity, updatedEntity, featuresForEntity, levelId)
            }

            if (updatedPoiCoords && changes.length === 1) {
                updatedEntity.hasMapChanged = true
                updatedEntity.latLng = updatedPoiCoords
            }
            return updatedEntity
        }
        const edits = map(enrichEntity, changes)

        if (selectors.isVenueV5(venueId, state) && !all(has('levelId'), edits)) {
            throw new Error(`No levelId for one of the updated entities`)
        }

        const { putFeaturesAndEntities, updatePOIs } = baseLoader()
        const updateEntities = isEntityMigrated ? putFeaturesAndEntities : updatePOIs

        updateEntities(venueId, edits)
            .then(restartQueueAndResolveWithUpdatedEntities)
            .catch(reject)
    })

    runQueue()
})

const runQueue = () => {
    if (_queueRunning) {
        return
    }
    const next = _poiUpdateQueue.shift()
    if (next) {
        next()
    }
}

export default scheduleEntityEdits

